import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import z from 'zod'

import { TUserNotificationsForm } from '@/forms/types'

export const UserNotificationsFormSchema = z.object({
  enableJobNotifications: z.boolean(),
  enableJobRecommendationsNotifications: z.boolean(),
})

interface IUseUserNotificationsFormParams {
  preloadedValues?: Partial<TUserNotificationsForm>
}

export const useUserNotificationsForm = ({
  preloadedValues,
}: IUseUserNotificationsFormParams = {}) => {
  const defaultValues = {
    enableJobNotifications: true,
    enableJobRecommendationsNotifications: true,
  }

  const form = useForm<TUserNotificationsForm>({
    defaultValues,
    resolver: zodResolver(UserNotificationsFormSchema),
    values: { ...defaultValues, ...preloadedValues },
  })

  const resetForm = () => form.reset(defaultValues)

  return {
    form,
    resetForm,
  }
}
